<template>
    <div
        class="campaigns"
    >
        <list
            :data="{
                list,
                pagination,
                hasLoading,
                headers: [
                    { type: 'default', value: 'beginDate' },
                    { type: 'default', value: 'endDate' },
                    { type: 'default', value: 'type' },
                    {
                        type: 'component',
                        value: 'progress',
                        component: () => import( /* webpackChunkName: 'ProgressBar' */ '@/components/bundles/bars/progress/ProgressBar' )
                    }, {
                        type: 'component',
                        translate: 'state',
                        value: 'id',
                        component: () => import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseStates' )
                    }
                ],
                destak: 'name',
                showId: true,
            }"
        />
        <widget-options />
    </div>
</template>

<script>
// hooks
import { listStructure } from '@/hooks/use-data';

export default {
    ...listStructure
};
</script>